import React from 'react';
import { ApolloProvider } from '@apollo/client';
import { IntlProvider } from 'react-intl';
import { ThemeProvider } from '@material-ui/core/styles';
import { createMuiTheme } from '@material-ui/core/styles';
import client from '../../lib/apolloClient';
import translations from '../../lib/i18n/translations.json';
import SuccessionPlansIndexPage from './pages/SuccessionPlansIndex';
import NewSuccessionPlanPage from './pages/NewSuccessionPlan';
import PlanBuilderPage from './PlanBuilderPage';
import PlanCompletionCelebrationPage from './pages/PlanCompletionCelebration';
import PlanExportPage from './pages/PlanExport';

// Simple theme wrapper if needed, or rely on Tailwind
const theme = createMuiTheme({
  palette: {
    primary: { main: '#0056b3' },
  },
});

// Wrapper to provide Apollo Context + IntlProvider, respects railsContext locale
const withApollo = (Component) => (props, railsContext) => {
  window.locale = (railsContext && railsContext.i18nLocale) || window.locale || 'en';
  const locale = window.locale;
  return (
    <IntlProvider locale={locale} messages={translations[locale] || translations.en}>
      <ApolloProvider client={client}>
        <ThemeProvider theme={theme}>
          <Component {...props} />
        </ThemeProvider>
      </ApolloProvider>
    </IntlProvider>
  );
};

export const SuccessionPlansIndex = withApollo(SuccessionPlansIndexPage);
export const NewSuccessionPlan = withApollo(NewSuccessionPlanPage);
export const PlanBuilder = withApollo(PlanBuilderPage);
export const PlanCompletionCelebration = withApollo(PlanCompletionCelebrationPage);
export const PlanExport = withApollo(PlanExportPage);

